<template>
	<div id="app">
		<transition
			v-if="$route.name == 'error_401' || $route.name == 'error_500' || $route.name == 'error_404' || $route.name == 'login' || $route.name == 'home' || $route.path == '/' || $route.name == 'commandAndDispatch'"
			name="el-fade-in">
			<router-view />
		</transition>

		<div v-else>
			<!-- <el-container> -->
			<el-header>
				<Header></Header>
			</el-header>
			<!-- <el-container> -->
			<!-- <el-aside width="200px"> -->
			<div class="Flex">
				<div :style="{ left: navLetf }" class="navBg">
					<!-- 路由递归组件 -->
					<div class="navBar">
						<div style='overflow: auto;max-height:calc(100vh - 70px);'>
							<navBar :model='menuList'></navBar>
						</div>
					</div>
					<!-- 静态二级导航  无法拓展三级 -->
					<!-- <div class="navBar">
						<div v-for="(val, ind) in menuList" :key="ind">
							父级盒子
							<div v-if="val.children && val.children.length != 0" :class="val.type ? 'navDadOpen' : ''"
								class="nav" @click="navSelect(ind)">
								<div class="navDad">
									<div>
										<span> {{ val.strName }} </span>
									</div>
									<img :class="val.type ? 'svgRight' : ''" alt=""
										src="@/assets/routerImg/rightArrows.svg" />
								</div>
								子级盒子
								<div :style="{ height: val.height }" class="navSonBg">
									<div class="navSon">
										子级
										<template v-for="(item, index) in val.children">
											<div v-if="item.strName != '事件详情'" :key="index"
												:class="(item.type || currPath === item.path) ? 'navSonSelect' : ''"
												@click.stop="navSonSelect(ind, index)">
												{{ item.strName }}
											</div>
										</template>

									</div>
								</div>
							</div>
							<div v-else>
								<div class="navSon" v-if="val.strName != '事件详情'">
									<div style="border-left: 0px"
										:class="(val.type || currPath === val.path) ? 'navSonSelect' : ''"
										@click.stop="navSonSelect(ind)">
										{{ val.strName }}
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<div :style="{ transform: 'rotate(' + angle + 'deg)' }" class="navClose" @click="changeNav()">
						<div>
							<i class="el-icon-arrow-left"></i>
						</div>
					</div>
				</div>
				<div :style="{ 'padding-left': paddingLeft }" style="
                                    transition: all 1s;
                                    min-width: 100%;
                                    box-sizing: border-box;
                                    height: calc(100vh - 60px);
                                    overflow: auto;
                                ">
					<transition name="el-fade-in">
						<router-view></router-view>
					</transition>

				</div>
			</div>
			<!-- </el-aside> -->
			<!-- <el-main> -->
			<!-- <transition name="fade-transform" mode="out-in">
                            <router-view class="view-wrap" />
                        </transition> -->
			<!-- </el-main> -->
			<!-- </el-container> -->
			<!-- </el-container> -->

		</div>
	</div>
</template>

<script>
import navBar from '@/components/navBar'
import Header from '@/layout/header'
import Sidebar from '@/layout/Sidebar'

import pages from '@/router/pages.js'
import router from '@/router/index.js'
import * as api from "@/api/request/dahuaApi/dahua.js";
export default {
	name: 'app',
	components: {
		Header,
		Sidebar,
		navBar
	},
	data() {
		return {
			menuList: [],
			navLetf: 0,
			angle: 0,
			paddingLeft: '200px',
		}
	},
	watch: {
		// 搜索
		$route: {
			deep: true,
			immediate: true,
			handler(to, from) {
				if (to.path != '/') {
					this.init()
				} else {
					this.menuList = []
				}
			},
		}
	},
	created() {
		// // 如果是到登录页 所以登录之后的页面为 一个菜单的第一个
		// if(this.$route.path == '/'){
		//     localStorage.setItem("checkEmergencyF", 0);
		//     localStorage.setItem("checkEmergencyZ", 0);
		// }
		this.keepaliveFun();
	},
	computed: {
		currPath() {
			return this.$route.path
		}
	},
	methods: {
		//初始化
		init() {
			console.log('this.menuList',this.menuList);
			//判断本地储存是否有路由配置 
			//因为监听路由每次都会触发 判断变量是否赋值 本地储存是否存在 
			// && JSON.stringify(this.menuList) === localStorage.getItem('routerArr')
			if (this.menuList?.length != 0 && localStorage.getItem('routerArr')) {
				const checkEmergencyF = localStorage.getItem("checkEmergencyF") ? localStorage.getItem(
					"checkEmergencyF") : 8888;
				if (checkEmergencyF == 8888) {
					// 父
					this.menuList[0].type = true // 打开
					if (this.menuList[0].children && this.menuList[0].children.length > 0) {
						if (this.menuList[0].type) {
							this.menuList[0].height = this.menuList[0].children.length * 50 + 'px' // 动态计算子路由高度
							this.$forceUpdate()
						} else {
							this.menuList[0].height = 0
							this.$forceUpdate()
						}
					}

					// 子
					// 所有的导航状态全部关闭
					this.menuList.forEach((val) => {
						if (val.children && val.children.length !== 0) {
							val.children.forEach((item) => {
								item.type = false
							})
						} else {
							val.type = false
						}
					})
					if (this.menuList[0].children && this.menuList[0].children.length > 0) { // 有子级  点击子级跳转页面 选中效果
						this.menuList[0].children[0].type = true // 选中
						this.go(this.menuList[0].children[0].strUrl)

					} else { // 无子级点击事件
						this.menuList[0].type = true // 选中
						this.go(this.menuList[0].strUrl)
					}


					localStorage.setItem("checkEmergencyF", 0);

				}
				return
			}
			console.log('渲染路由')
			this.menuList = JSON.parse(localStorage.getItem('routerArr')) || []

			var data = []
			//路由动态添加
			// res.resultData.userMenuAuthority
			//循环动态路由 进行动态路由添加
			function for_router(router_data, type = false) { //type 为false 表示一级 true 表示二级 三级 。。。
				var _this = this
				router_data.forEach((item) => {
					if (item.children && item.children.length > 0) {
						for_router(item.children, true)
					} else {
						if (type) {
							data.push({
								path: '/' + item.strUrl,
								name: item.strUrl,
								component: () => import('@/views/' + item.strModPK + '/' + item.strUrl)
							})
						
						} else {
							data.push({
								path: '/' + item.strUrl,
								name: item.strUrl,
								component: () => import('@/views/' + item.strUrl)
							})
						}
					}
				})
			}
			for_router(this.menuList)

			/* this.menuList.forEach((item, index) => {
				if (item.children && item.children.length > 0) {
					item.children.forEach(val => {
						data.push({
							path: '/' + val.strUrl,
							name: val.strUrl,
							component: () => import('@/views/' +
								val.strModPK + '/' + val
								.strUrl)
						})
					})
				} else {
					data.push({
						path: '/' + item.strUrl,
						name: item.strUrl,
						component: () => import('@/views/' + item.strUrl)
					})
				}
			}) */


			router.addRoutes(data)
			// this.menuList = pages.pages
			const checkEmergencyF = localStorage.getItem("checkEmergencyF") ? localStorage.getItem("checkEmergencyF") :
				0;
			const checkEmergencyZ = localStorage.getItem("checkEmergencyZ") ? localStorage.getItem("checkEmergencyZ") :
				0;
			if (checkEmergencyZ == '9999') {
				this.navSonSelect(checkEmergencyF)
			} else {
				if (checkEmergencyF && this.menuList[checkEmergencyF].children.length != 0) {
					this.navSelect(checkEmergencyF) // 父级导航点击事件
					if (checkEmergencyZ) {
						this.menuList[checkEmergencyF].children[checkEmergencyZ].type = true // 选中
					} else {
						this.menuList[checkEmergencyF].children[0].type = true // 选中
					}
				} else {
					this.navSelect(0) // 父级导航点击事件
				}
			}
		},
		// 子级点击事件
		navSonSelect(ind, index) {
			// 所有的导航状态全部关闭
			this.menuList.forEach((val) => {
				if (val.children && val.children.length !== 0) {
					val.children.forEach((item) => {
						item.type = false
					})
				} else {
					val.type = false
				}
			})
			if (this.menuList[ind].children && this.menuList[ind].children.length > 0) { // 有子级  点击子级跳转页面 选中效果
				this.menuList[ind].children[index].type = true // 选中
				this.go(this.menuList[ind].children[index].strUrl)
				localStorage.setItem("checkEmergencyF", ind);
				localStorage.setItem("checkEmergencyZ", index);

			} else { // 无子级点击事件
				this.menuList[ind].type = true // 选中
				this.go(this.menuList[ind].strUrl)
				localStorage.setItem("checkEmergencyF", ind);
				localStorage.setItem("checkEmergencyZ", 9999);
			}
		},
		// 父级导航点击事件
		navSelect(ind) {
			this.menuList[ind].type = !this.menuList[ind].type
			if (this.menuList[ind].children && this.menuList[ind].children.length > 0) {
				var num = 0
				this.menuList[ind].children.forEach(val => {
					if (val.strName == '事件详情') {
						num++
					}
				})
				if (this.menuList[ind].type) {
					this.menuList[ind].height = (this.menuList[ind].children.length - num) * 50 + 'px' // 动态计算子路由高度
					// localStorage.setItem("checkEmergencyF", ind);
					this.$forceUpdate()

					// this.menuListSonSelect(0, 0) // 默认跳转子路由第一个页面
				} else {
					this.menuList[ind].height = 0
					this.$forceUpdate()
				}
			}
		},
		// 跳转页面
		go(url) {


			this.$router.push({
				path: url
			})

		},
		// 左侧导航栏关闭 展开 事件
		changeNav() {
			if (this.navLetf === 0) {
				this.navLetf = '-175px'
				this.paddingLeft = '50px'
				this.angle = 180
			} else {
				this.navLetf = 0
				this.paddingLeft = '200px'
				this.angle = 0
			}
		},
		keepaliveFun() {
			api.keepalive().then(() => {
				setTimeout(() => {
					this.keepaliveFun();
				}, 20000);
			});
		},
	}

}
</script>

<style lang="scss">
* {
	padding: 0;
	margin: 0;
}

.el-notification {
	top: 50px !important;
}

.flexBox {
	display: flex;
	align-items: center;
	width: 100%;
	// height: calc(100vh - 60px);
}

.el-menu {
	height: 100% !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
	background-color: #3135a0 !important;
	// color: #f5222d !important;
}

.el-menu-item.is-active {
	//   color: #f5222d !important;
	background-color: #3135a0 !important;
	//   border-right: 3px solid #f5222d;
}

.el-container {
	height: calc(100vh - 60px);
}


.navDad {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 16px;
	height: 60px;
	line-height: 60px;
	// border-bottom: 1px solid #555c79;
	cursor: pointer;
	box-sizing: border-box;
	margin: 0 8px;
}

.navDad>div {
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.navDad>div>img {
	width: 16px;
	margin-right: 12px;
}

.navDad>img {
	width: 10px;
	transition: all 0.4s;
}

.svgRight {
	transform: rotate(90deg);
}

.navDad>div>span {
	display: block;
	font-size: 16px;
	// color: #ffffff;
	color: #000000;

}

.navBg {
	width: 200px;
	height: calc(100vh - 60px);
	// background-color: #32373e;
	background-color: #ffffff;
	position: fixed;
	left: 0;
	top: 60px;
	transition: left 1s;
	z-index: 999;


}

.navBar {
	height: calc(100vh - 60px);
	overflow: auto;
	padding-bottom: 240px;
	box-shadow: 15px 10px 20px 0px rgba(0, 0, 0, 0.2);
}

.navSonBg {
	height: 0px;
	transition: height 0.3s;
	overflow: hidden;
	// padding-left: 10px;
}

// .navSon{
// 	padding-left: 15px;
// }
.navSon>div {
	height: 50px;
	line-height: 50px;
	// color: #939cb4;
	color: #000000;
	text-align: left;
	padding: 0 24px;
	// border-bottom: 1px solid #555c79;
	cursor: pointer;
	font-size: 16px;
	// margin: 0 8px;
	white-space: nowrap;

	border-left: 5px solid #fff;
}

.navSon>div:hover {
	height: 50px;
	line-height: 50px;
	// color: #939cb4;
	color: #000000;
	text-align: left;
	// padding: 0 24px;
	// border-bottom: 1px solid #555c79;
	cursor: pointer;
	font-size: 16px;
	// margin: 0 8px;
	white-space: nowrap;
	border-left: 5px solid #e6f0ff;
	background: #e6f0ff;
	color: #006bff !important;

}

.navDadOpen {
	// background: #000000;
	background: #ffffff;
	margin-top: 2px;

}

.navSonSelect::before {
	content: '';
	position: absolute;
	left: -8px;
	top: 0;
	display: inline-block;
	width: 8px;
	height: 100%;
	background: #006bff;
}

.navSonSelect {
	// background: #00b38a;
	// color: #fff !important;
	position: relative;
	// border-left: 5px solid #006bff !important;
	background: #e6f0ff;
	color: #006bff !important;
}

.navClose {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background-color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	right: -25px;
	bottom: 27px;
	cursor: pointer;
	transition: all 1s;
	box-shadow: 0px 0px 10px 0px #ccc;
}

.navClose>div {
	width: 30px;
	height: 30px;
	background: #00b38a;
	border-radius: 50%;
	font-size: 20px;
	color: #fff;
	text-align: center;
	line-height: 30px;
}

.strNameImg {
	width: 16px;
	height: 16px;
}


/* 设置滚动条的样式 */
::-webkit-scrollbar {
	width: 8px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
	-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
	border-radius: 8px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
	border-radius: 8px;
	background: rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

::-webkit-scrollbar-thumb:window-inactive {
	background: rgba(0, 110, 255, 0.5);
}


.el-dialog__header {
	/* border-bottom: 1px solid #f6f7fb; */
	// background: #f6f7fb !important;
}

.el-dialog__body {
	padding-left: 20px;
}

.el-dialog {
	margin-top: 10vh !important;
}
</style>
